<template>
  <div
    class="card flex items-center relative"
    :class="{
      'card-active': item.quantity && !notFound,
      'card-error mb-7': notFound,
    }"
  >
    <div
      v-if="notFound"
      class="bg-flexopus-danger-default text-white flex items-center justify-center h-5 rounded-b-lg text-xs absolute -bottom-5 left-0 px-4 mx-2 w-[calc(100%-1rem)]"
    >
      {{ $t('Services.Item.NotFound') }}
    </div>
    <dialog
      v-if="item.image_url"
      :id="'image-dialog-' + item.id"
      ref="imageDialog"
      class="rounded-lg p-0 shadow"
    >
      <div class="flex items-center justify-between mx-2 py-2 mb-1 border-b">
        <span class="px-1 text-base font-medium">{{ item.name }}</span>
        <button
          :commandfor="'image-dialog-' + item.id"
          command="close"
          class="icon-btn icon-btn-primary"
        >
          <X class="w-5 h-5" />
        </button>
      </div>
      <img
        :src="item.image_url"
        class="max-h-[90vh] max-w-[90vw]"
      >
      <div class="flex justify-end mx-2 py-2 mt-1 border-t text-sm text-neutral-500 text-right">
        <span class="px-1 font-mono">{{ item.item_code }}</span>
      </div>
    </dialog>
    <button
      v-if="item.image_url"
      class="cursor-zoom-in"
      @click="$refs.imageDialog.showModal()"
    >
      <img
        :src="item.image_url"
        class="rounded-md h-16 w-16 object-cover mr-3 border border-neutral-300"
      >
    </button>
    <div
      v-else
      class="h-16 w-16 bg-gray-300 rounded-md mr-3"
    />
    <div class="mr-3">
      <div class="text-sm font-medium leading-normal">
        {{ item.name }}
      </div>
      <div class="text-xs text-neutral-500 leading-normal">
        {{ item.category }}
      </div>
      <div class="text-xs text-neutral-500 leading-normal">
        <span
          v-if="typeof item.price === 'number'"
          class="text-neutral-500 text-xs"
        >
          {{ item.price }} €
        </span>
      </div>
    </div>
    <div class="ml-auto flex flex-col items-end h-16">
      <div
        v-if="typeof item.price === 'number' && item.quantity"
        class="text-sm text-microsoft-blue-default"
      >
        {{ item.price * (item.quantity || 1) }} €
      </div>
      <button
        v-if="!item.quantity"
        class="rounded flex justify-around h-8 border border-neutral-300 text-xs items-center hover:border-neutral-500 transition mt-auto"
        style="min-width: 92px;"
        @click="$emit('change', 1)"
      >
        {{ $t('Services.Item.Add') }}
      </button>
      <div
        v-else
        class="rounded flex justify-between h-8 border border-neutral-300 text-xs items-center hover:border-neutral-500 transition overflow-hidden mt-auto"
        style="min-width: 92px;"
      >
        <button
          class="flex items-center justify-center hover:bg-neutral-300 transition text-base"
          style="height: 30px; width: 30px;"
          @click="$emit('change', item.quantity - 1)"
        >
          <Minus class="h-4 w-4" />
        </button>
        <input
          :value="item.quantity"
          type="number"
          class="bg-transparent text-center focus:outline-none w-8"
          min="0"
          :max="item.order_limit"
          :step="1"
          @change="$emit('change', parseInt($event.target.value) || 0)"
        >
        <button
          class="flex items-center justify-center hover:bg-neutral-300 transition text-base disabled:text-neutral-400 disabled:cursor-not-allowed disabled:hover:bg-transparent"
          style="height: 30px; width: 30px;"
          :disabled="item.order_limit && item.quantity >= item.order_limit"
          @click="$emit('change', item.quantity + 1)"
        >
          <Plus class="h-4 w-4" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Plus, Minus, X } from 'lucide-vue'

export default {
  components: {
    Minus,
    Plus,
    X,
  },
  props: {
    item: { type: Object, required: true },
    notFound: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss" scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
    -moz-appearance: textfield; /* Firefox */
    appearance: textfield;
}
</style>
